import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_ds_get_materials_with_inventoryService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { project_id: number, material_lookup_code?: string }): 
  Promise<{ result: { Lot?: { MaterialId?: number }, LicensePlate?: { WarehouseId?: number } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.project_id)) {
      $missingRequiredInParams.push('\'project_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { project_id: number, material_lookup_code?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Lot?: { MaterialId?: number }, LicensePlate?: { WarehouseId?: number } }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.project_id)) {
      $missingRequiredInParams.push('\'project_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { project_id: number, material_lookup_code?: string, $keys: { Lot?: { MaterialId?: number }, LicensePlate?: { WarehouseId?: number } }[] }): 
  Promise<{ result: { Lot?: { MaterialId?: number }, LicensePlate?: { WarehouseId?: number } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.project_id)) {
      $missingRequiredInParams.push('\'project_id\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      project_id: number, material_lookup_code?: string    }) {
        if(isNil($inParams.project_id)) {
          return true; 
        }
      return false;
    }
}
